import AtualizacaoPlanoService from "@/services/AtualizacaoPlanoService";

export const atualizacaoPlano = {
  namespaced: true,
  state: {
    atualizacaoPlano: {},
  },
  actions: {
    getAtualizacaoPlano({ commit }, payload) {
      return AtualizacaoPlanoService.GetAtualizacaoPlano(payload).then(
        (atualizacaoPlano) => {
          return Promise.resolve(atualizacaoPlano);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    postAtualizacaoPlano({ commit }, payload) {
      return AtualizacaoPlanoService.PostAtualizacaoPlano(payload).then(
        (atualizacaoPlano) => {
          return Promise.resolve(atualizacaoPlano);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    putAtualizacaoPlano({ commit }, payload) {
      return AtualizacaoPlanoService.PutAtualizacaoPlano(payload).then(
        (atualizacaoPlano) => {
          return Promise.resolve(atualizacaoPlano);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    deleteAtualizacaoPlano({ commit }, payload) {
      return AtualizacaoPlanoService.DeleteAtualizacaoPlano(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    getAtualizacaoPlanoOData({ commit }, payload) {
      return AtualizacaoPlanoService.GetAtualizacaoPlanoOData(payload).then(
        (atualizacaoPlano) => {
          return Promise.resolve(atualizacaoPlano);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    postAtualizacaoPlanoConfirmarPlano({ commit }, payload) {
      return AtualizacaoPlanoService.PostAtualizacaoPlanoConfirmarPlano(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    postAtualizacaoPlanoCancelarPlano({ commit }, payload) {
      return AtualizacaoPlanoService.PostAtualizacaoPlanoCancelarPlano(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default atualizacaoPlano;
